export interface ImpVehicle {
  custCd: string;
  Brand: string;
  vinNo: string;
  blNo: string;
  vesselName?: string;
  ETD?: Date;
  ETA?: Date;
  itemCd: string;
  description: string;
  package?: string;
  color?: string;
  modelYear: string;
  productionDate?: Date;
  unit: number;
  unitPrice?: string;
  weight?: string;
  dealerCode?: string;
  refundCode?: string;
  outDate?: Date;
  docDate?: Date;
  submitDate?: Date;
  approveDate?: Date;
  refundDate?: Date;
  refundAmount?: string;
  cusReportNumber?: string;
  cusReportStatus?: string;
  remark?: string;
  mrn?: string;
  msn?: string;
  hsn?: string;
  yardCode?: string;
  yardName?: string;
  reqTime?: Date;
  appTime?: Date;
  inspTime?: Date;
  aprvTime?: Date;
  appType?: string;
  buyer?: string;
  netWeight?: string;
  optionCount?: number;
  invNo?: string;
  invDate?: Date;
  delayReason?: string;
  cur?: string;
  Gs?: number;
  Vat?: number;
  EduTax?: number;
  IndvTax?: number;
  TotalTax?: number;
  isFTA?: boolean;
  taxUpdateTime?: Date;
  totalTaxationKRW?: number;
  ambientAir?: string;
}

export const impVehicleDummy: ImpVehicle = {
  custCd: "",
  Brand: "",
  vinNo: "",
  blNo: "",
  ETD:  new Date(),
  ETA:  new Date(),
  itemCd: "",
  description: "",
  package: "",
  color: "",
  modelYear: "",
  productionDate:  new Date(),
  unit: -1,
  unitPrice: "",
  weight: "",
  dealerCode: "",
  refundCode: "",
  outDate:  new Date(),
  docDate: new Date(),
  submitDate:  new Date(),
  approveDate:  new Date(),
  refundDate:  new Date(),
  refundAmount: "",
  cusReportNumber: "",
  cusReportStatus: "",
  remark: "",
  mrn: "",
  msn: "",
  hsn: "",
  yardCode: "",
  yardName: "",
  reqTime:  new Date(),
  appTime:  new Date(),
  inspTime:  new Date(),
  aprvTime:  new Date(),
  appType: "",
  buyer: "",
  netWeight: "",
  optionCount: -1,
  invNo: "",
  invDate: new Date(),
  delayReason: "",
  cur: "",
  Gs: -1,
  Vat: -1,
  EduTax: -1,
  IndvTax: -1,
  TotalTax: -1,
  isFTA: false,
  taxUpdateTime:  new Date(),
  totalTaxationKRW: -1,
  ambientAir: "",
};


export interface ImpVehiclePartItems {
  CUST_CD: string;
  ITEM_CD: string;
  CUST_FIRM?: string;
  description?: string;
  components?: string;
  hs?: string;
  ftaYN?: string;
  Std_Gname?: string;
  Exc_Gname?: string;
  amt?: string;
  needLabel?: boolean;
  elecDailyLaw?: boolean;
  radioWaveLaw?: boolean;
  chemEvalLaw?: boolean;
  chemManageLaw?: boolean;
  childrenLaw?: boolean;
  foodLaw?: boolean;
  needBosu?: boolean;
  isHolded?: boolean;
  recycle?: boolean;
  dispose?: boolean;
  chemEvalOK?: boolean;
  plant?: boolean;
  elecDailyOK?: boolean;
  radioWaveOK?: boolean;
  chemManageOK?: boolean;
  childrenOK?: boolean;
  foodOK?: boolean;
  plantOK?: boolean;
  vehicleManageLaw?: boolean;
  vehicleManageOK?: boolean;
  remark?: string;
  regID?: string;
  regTime?: Date;
  modID?: string;
  modTime?: Date;
  ORI_ST_MARK1?: string;
  Gs_Divi?: string;
  korLabelText?: string;
  specification?: string;
  livingChem?: boolean;
  livingChemOK?: boolean;
  isRR?: boolean;
  Gs_Divi_F?: boolean;
  isForLab?: boolean;
  itemNameCode?: string;
  producedDateInfo?: string;
  standardCode?: string;
}


export const EntityMap: Record<string, any> = {
  ImpVehiclePartItems: {
    CUST_CD: "",
    ITEM_CD: "",
    CUST_FIRM: "",
    description: "",
    components: "",
    hs: "",
    ftaYN: "",
    Std_Gname: "",
    Exc_Gname: "",
    amt: "",
    needLabel: false,
    elecDailyLaw: false,
    radioWaveLaw: false,
    chemEvalLaw: false,
    chemManageLaw: false,
    childrenLaw: false,
    foodLaw: false,
    needBosu: false,
    isHolded: false,
    recycle: false,
    dispose: false,
    chemEvalOK: false,
    plant: false,
    elecDailyOK: false,
    radioWaveOK: false,
    chemManageOK: false,
    childrenOK: false,
    foodOK: false,
    plantOK: false,
    vehicleManageLaw: false,
    vehicleManageOK: false,
    remark: "",
    regID: "",
    regTime: new Date(),
    modID: "",
    modTime: new Date(),
    ORI_ST_MARK1: "",
    Gs_Divi: "",
    korLabelText: "",
    specification: "",
    livingChem: false,
    livingChemOK: false,
    isRR: false,
    Gs_Divi_F: false,
    isForLab: false,
    itemNameCode: "",
    producedDateInfo: "",
    standardCode: "",
  },
  // ImpVehicle 더미 객체 작성
  ImpVehicle: {
    custCd: "",
    Brand: "",
    vinNo: "",
    blNo: "",
    blDate: new Date(),
    impNo: "",
    impDate: "",
    ETD: new Date(),
    ETA: new Date(),
    itemCd: "",
    description: "",
    package: "",
    color: "",
    modelYear: "",
    productionDate: new Date(),
    unit: 0,
    unitPrice: "",
    weight: "",
    dealerCode: "",
    refundCode: "",
    outDate: new Date(),
    docDate: new Date(),
    submitDate: new Date(),
    approveDate: new Date(),
    refundDate: new Date(),
    refundAmount: "",
    cusReportNumber: "",
    cusReportStatus: "",
    remark: "",
    mrn: "",
    msn: "",
    hsn: "",
    yardCode: "",
    yardName: "",
    reqTime: new Date(),
    appTime: new Date(),
    inspTime: new Date(),
    aprvTime: new Date(),
    appType: "",
    buyer: "",
    netWeight: "",
    optionCount: 0,
    invNo: "",
    invDate: new Date(),
    delayReason: "",
    cur: "",
    Gs: 0,
    Vat: 0,
    EduTax: 0,
    IndvTax: 0,
    TotalTax: 0,
    isFTA: false,
    taxUpdateTime: new Date(),
    totalTaxationKRW: 0,
    ambientAir: "",
  },

  IndvReduction: {
    id: 0,
    vin: "",
    type: "",
    desc: "",
    modelYear: "",
    dpVolume: 0,
    qty: null,
    status: null,
    receivedAt: null,
    appliedAt: null,
    approvedAt: null,
    paidAt: null,
    crn: null,
    bank: null,
    accntNo: null,
    amount: null,
    gs: null,
    edu: null,
    aggri: null,
    vat: null,
    alcohol: null,
    indv: null,
    trans: null,
    salesDate: null,
    deadLine: null,
    appNumber: null,
    paymentNumber: null,
    totalRefund: null,
    totalTaxationKRW: null,
    buyerName: "",
    buyerCompanyName: "",
    buyerAddress: "",
    buyerPlace: "",
    buyerCRN: "",
    buyerSSNumber: "",
    buyerTel: "",
    taxOffice: "",
    dealerRepName: "",
    dealerCrn: "",
    dealerCompanyName: "",
    dealerSSNumber: "",
    dealerCompanyAddress: "",
    dealerSalesAt: "",
    dealerCompanyTel: "",
    registeredAt: null,
    vehicleRegNo: "",
    createdAt: new Date(),
    updatedAt: new Date(),
    dg: "",
    importNumber: "",
    expectedAppliedAt: null,
    brand: null,
    reducedIndv: null,
    reducedEdu: null,
    pre_disposal: null,
    aged_vehicle_vin: null,
    aged_vehicle_reg_no: null,
    aged_vehicle_reg_date: null,
    reduced_vat: null,
    biz_drop_site_no: null,
    export_drop_site_no: null,
    ownership_now: null,
    deregistration_date: null,
    customs: null,
    refund_issued_date: null,
    buyer_sign_image_link: null,
    dealer_sales_office_location: null,
    eco_vehicle_type: null,
  }
};
